import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CardSeplag from "../../../../components/CardSeplag";

import AvaliacaoProgramaRagIndicador from "./indicador";
import AvaliacaoProgramaRagResultado from "./resultados";

import {
  buscarItemPrograma,
  buscarOdsPrograma,
  buscarPreenchimentoQuestoesInd,
  FormIdentificacaoPrograma as initForm,
} from "../../../../service/Rag/AvaliacaoPrograma";

import { useSelector } from "react-redux";
import Rotulo from "../../../../components/RotuloSeplag";
import AnaliseProgramaSeplag from "./analiseSeplag/AnaliseProgramaSeplag";
import AvaliacaoProgramaRagSugestao from "./sugestao";
import CardSeplagScrol from "../../../../components/CardSeplag/CardSeplagScrol";
import imagem01 from "../../../../assets/img/ods/SDG-1.svg";
import imagem02 from "../../../../assets/img/ods/SDG-2.svg";
import imagem03 from "../../../../assets/img/ods/SDG-3.svg";
import imagem04 from "../../../../assets/img/ods/SDG-4.svg";
import imagem05 from "../../../../assets/img/ods/SDG-5.svg";
import imagem06 from "../../../../assets/img/ods/SDG-6.svg";
import imagem07 from "../../../../assets/img/ods/SDG-7.svg";
import imagem08 from "../../../../assets/img/ods/SDG-8.svg";
import imagem09 from "../../../../assets/img/ods/SDG-9.svg";
import imagem10 from "../../../../assets/img/ods/SDG-10.svg";
import imagem11 from "../../../../assets/img/ods/SDG-11.svg";
import imagem12 from "../../../../assets/img/ods/SDG-12.svg";
import imagem13 from "../../../../assets/img/ods/SDG-13.svg";
import imagem14 from "../../../../assets/img/ods/SDG-14.svg";
import imagem15 from "../../../../assets/img/ods/SDG-15.svg";
import imagem16 from "../../../../assets/img/ods/SDG-16.svg";
import imagem17 from "../../../../assets/img/ods/SDG-17.svg";
import { Image } from "primereact/image";
import AvaliacaoProgramaRagExecucao from "./componentExecucao/AvaliacaoProgramaRagExecucao";

const AvaliacaoProgramaRag = () => {
  const location = useLocation();
  const [form, setForm] = useState(initForm);
  const [parametroExercicio, setParametroExercicio] = useState(location.state.parametroExercicio);
  const [dadosItemPrograma, setDadosItemPrograma] = useState(null);
  const [camposQuestionarioResultado, setCamposQuestionarioResultado] = useState();
  const [camposQuestionarioExecucao, setCamposQuestionarioExecucao] = useState();
  const [camposQuestionarioSugestao, setCamposQuestionarioSugestao] = useState();
  const [perfilAcesso, setPerfilAcesso] = useState(false);
  const [idenPessoaResp, setIdenPessoaResp] = useState(null);
  const userPerfil = useSelector((state) => state.userReducer.user.contaAcesso.authorities);
  const [percent, setPercent] = useState(0);
  const [listaOds, setListaOds] = useState();
  const [abaTelaConfirmada, setAbaTelaConfirmada] = useState(false);
  const [idPPA, setidPPA] = useState(0);
  const [listaIdIndicador, setListaIdIndicador] = useState();
  const [idExercicio, setIdExercicio] = useState();

  let history = useHistory();

  useEffect(() => {
    permission();
    setForm(location.state.data);
    setIdenPessoaResp(location.state.data.idenPessoaResp);
    buscarItemPrograma(location.state.data.idView).then(async (res) => {
      setDadosItemPrograma(res.data);
      montarQuestionario(res.data.questionarioRag);

      setidPPA(location.state.data.idenPPA); //recupera o PPAId para guardar e utilizar na busca do Programa
      //tratamento para coletar o percentual das perguntas preenchidas pelo total que perguntas, na entrada da tela---
      // console.log("Obj",res.data.dadosItemRag.objetivos)
      // console.log("Ind_0",res.data.dadosItemRag.objetivos[0].indicadores)
      // console.log("Ind_1",res.data.dadosItemRag.objetivos[1].indicadores)

      // Concatenar os idenIndicador(Ids dos Indicadores dos Objetivos) em uma lista
      const aListaId = res.data.dadosItemRag.objetivos.flatMap((obj) =>
        obj.indicadores.map((ind) => ind.idenIndicador)
      );
      setListaIdIndicador(aListaId);

      const idExercicioAux = res.data.dadosItemRag.exercicio.idenExercicio;
      setIdExercicio(idExercicioAux);

      //console.log("ListaFinal ano: " + res.data.dadosItemRag.exercicio.idenExercicio + " listaid: " + aListaId )

      //Chama os itens do questionario a nivel do INDICADOR, para entrar no calculo
      const questionarioAux = await buscarPreenchimentoQuestoesInd(
        res.data.dadosItemRag.exercicio.idenExercicio,
        "INDICADOR",
        { listaId: aListaId }
      );
      //console.log("questionarioAux",questionarioAux);

      const qtdPerguntasIndicadores = questionarioAux.filter((item) => item.flagObrigatorio === "S");
      const qtdPerguntasIndicadoresRespondidas = questionarioAux.filter(
        (item) =>
          item.flagObrigatorio === "S" && item.valrRespostaItemQuest !== null && item.valrRespostaItemQuest !== ""
      );

      //Realiza o calculo do percentual, com os dados dos questionarios geral + os itens do questionarios do indicador
      //console.log(res.data.questionarioRag)
      const preenchidas =
        res.data.questionarioRag.filter(
          (questao) =>
            questao.valrRespostaItemQuest !== null &&
            questao.valrRespostaItemQuest !== "" &&
            questao.flagObrigatorio === "S"
        ).length + qtdPerguntasIndicadoresRespondidas.length;
      const totalPerguntas =
        res.data.questionarioRag.filter((questao) => questao.flagObrigatorio === "S").length +
        qtdPerguntasIndicadores.length;
      if (totalPerguntas > 0) {
        const percentual = (preenchidas / totalPerguntas) * 100;
        setPercent(percentual);
      } else {
        setPercent(0);
      }
      //console.log("preenchidas",preenchidas, "totalperguntas", totalPerguntas)
      //----------------

      //console.log("location.state.data",location.state.data.programa)
      buscarOdsPrograma(location.state.data.programa.idFiplanPrograma).then((res) => {
        // Verifica se res.data é um array antes de tentar fazer o sort
        if (Array.isArray(res.data)) {
          const sortedList = res.data.sort((a, b) => a.codgOds - b.codgOds);
          setListaOds(sortedList);
        } else {
          // Caso res.data não seja um array, você pode definir um array vazio
          setListaOds([]);
        }
      });
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (abaTelaConfirmada) {
        // Precisa percorrer os questionários editáveis (Resultado, Execução) para coletar os valores preenchidos nas respostas e refazer os cálculos.
        // Aba Resultados
        const camposQResultAux = JSON.parse(camposQuestionarioResultado);
        dadosItemPrograma.questionarioRag.forEach((item) => {
          if (item.descCategoriaPergunta === "Resultados") {
            if (item.valrRespostaItemQuest === null && item.flagObrigatorio === "S") {
              camposQResultAux.forEach((result) => {
                if (result.rowId === item.rowId) {
                  item.valrRespostaItemQuest = result.valrRespostaItemQuest; // Atualiza para fazer o cálculo do percentual
                }
              });
            }
          }
        });

        // Aba Execução
        const camposQExecAux = JSON.parse(camposQuestionarioExecucao);
        dadosItemPrograma.questionarioRag.forEach((item) => {
          if (item.descCategoriaPergunta === "Execução Orçamentária e Financeira") {
            if (item.valrRespostaItemQuest === null && item.flagObrigatorio === "S") {
              camposQExecAux.forEach((result) => {
                if (result.rowId === item.rowId) {
                  item.valrRespostaItemQuest = result.valrRespostaItemQuest; // Atualiza para fazer o cálculo do percentual
                }
              });
            }
          }
        });

        // Refaz o cálculo das perguntas preenchidas

        // Chama os itens do questionário do nível do INDICADOR, do banco para apresentar o percentual atualizado
        const questionarioAuxTelaConfirmada = await buscarPreenchimentoQuestoesInd(idExercicio, "INDICADOR", {
          listaId: listaIdIndicador,
        });

        const qtdPerguntasIndicadores = questionarioAuxTelaConfirmada.filter((item) => item.flagObrigatorio === "S");
        const qtdPerguntasIndicadoresRespondidas = questionarioAuxTelaConfirmada.filter(
          (item) =>
            item.flagObrigatorio === "S" && item.valrRespostaItemQuest !== null && item.valrRespostaItemQuest !== ""
        );

        const preenchidas =
          dadosItemPrograma.questionarioRag.filter(
            (questao) =>
              questao.valrRespostaItemQuest !== null &&
              questao.valrRespostaItemQuest !== "" &&
              questao.flagObrigatorio === "S"
          ).length + qtdPerguntasIndicadoresRespondidas.length;
        const totalPerguntas =
          dadosItemPrograma.questionarioRag.filter((questao) => questao.flagObrigatorio === "S").length +
          qtdPerguntasIndicadores.length;
        if (totalPerguntas > 0) {
          const percentual = (preenchidas / totalPerguntas) * 100;
          setPercent(percentual);
          setAbaTelaConfirmada(false);
        } else {
          setPercent(0);
        }
      }
    };

    fetchData();
  }, [abaTelaConfirmada]);

  const permission = () => {
    for (let i = 0; i < userPerfil.length; i++) {
      if (
        userPerfil[i].nomeRole === "MONRL_ADMIN_CENTRAL" ||
        userPerfil[i].nomeRole === "MONRL_ANALISTA" ||
        userPerfil[i].nomeRole === "MONRL_LANCAMENTO" ||
        userPerfil[i].nomeRole === "MONRL_ADMIN_SETORIAL"
      )
        setPerfilAcesso(true);
    }
  };

  function montarQuestionario(questionario) {
    let questResultados = mapQuestionario(
      questionario.filter((questP) => questP.descCategoriaPergunta === "Resultados")
    );
    setCamposQuestionarioResultado(JSON.stringify(questResultados));

    let questExecucao = mapQuestionario(
      questionario.filter((questP) => questP.descCategoriaPergunta === "Execução Orçamentária e Financeira")
    );
    setCamposQuestionarioExecucao(JSON.stringify(questExecucao));

    let questSugestao = mapQuestionario(
      questionario.filter((questP) => questP.descCategoriaPergunta === "Sugestão de Melhoria")
    );
    setCamposQuestionarioSugestao(JSON.stringify(questSugestao));
  }

  function mapQuestionario(qmap) {
    let retorno = qmap
      .map((questao) => {
        return {
          ...questao,
          id: questao.rowId,
          label: `${questao.numrPergunta} - ${questao.descPergunta}`,
          data: questao.valrRespostaItemQuest,
          type: questao.siglTipoPergunta,
          options: questao.opcoes.split("/").map((opcao) => {
            return {
              code: opcao,
              name: opcao,
            };
          }),
        };
      })
      .sort((a, b) => {
        return a.numrOrdemPergunta - b.numrOrdemPergunta;
      });

    return retorno;
  }

  function titleCard() {
    let titulo =
      form && form.descricaoItem
        ? "UO: " +
          form.unidadeOrcamentaria.descricaoFiplan +
          " - PROGRAMA: " +
          form.codFiplanItem +
          " " +
          form.descricaoItem
        : "";
    return <span>{titulo}</span>;
  }

  const tabIdentificacaoTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".9em" }}
        >
          <i className="pi pi-tags" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tabIndicadoresTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".9em" }}
        >
          <i className="pi pi-chart-line" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tabResultadosTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".9em" }}
        >
          <i className="pi pi-check-square" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tabExecucaoTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".9em" }}
        >
          <i className="pi pi-cog" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tabSugestaoTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".9em" }}
        >
          <i className="pi pi-comments" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tabAnaliseTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".9em" }}
        >
          <i className="pi pi-align-center" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  const imagesAux = {
    "SDG-1.svg": imagem01,
    "SDG-2.svg": imagem02,
    "SDG-3.svg": imagem03,
    "SDG-4.svg": imagem04,
    "SDG-5.svg": imagem05,
    "SDG-6.svg": imagem06,
    "SDG-7.svg": imagem07,
    "SDG-8.svg": imagem08,
    "SDG-9.svg": imagem09,
    "SDG-10.svg": imagem10,
    "SDG-11.svg": imagem11,
    "SDG-12.svg": imagem12,
    "SDG-13.svg": imagem13,
    "SDG-14.svg": imagem14,
    "SDG-15.svg": imagem15,
    "SDG-16.svg": imagem16,
    "SDG-17.svg": imagem17,
  };

  const getImageSrc = (nomeImagem) => imagesAux[nomeImagem];

  function condicao(campo, campos) {
    if (campo.infoDependencia) {
      let arrayDependencia = campo.infoDependencia.split("@");
      let idenQuestionarioPergunta = arrayDependencia[0];
      if (arrayDependencia[1]) {
        let campoArrayValues = arrayDependencia[1].split("||");
        let perguntaDependente = campos.find((camp) => camp.idenQuestionarioPergunta == idenQuestionarioPergunta);
        let ativarPerguntaDependente = false;
        campoArrayValues.forEach((itemValue) => {
          if (itemValue === perguntaDependente.data) {
            ativarPerguntaDependente = true;
          }
        });
        return ativarPerguntaDependente;
      } else {
        return true;
      }
    }
    return true;
  }

  function formatarPercentual(perc) {
    //Recupera o numero inteiro do percentual e concatena o sinal de %
    const parteInteira = Math.floor(perc);
    return `${parteInteira}%`;
  }

  //Controle para identificar se o ano eh igual ou superior a 2024
  //Verifica se dadosItemPrograma e dadosItemPrograma.dadosItemRag são válidos
  const ano = dadosItemPrograma?.dadosItemRag?.exercicio?.ano;
  const exercicio2024 = ano !== undefined ? ano >= 2024 : false;

  return (
    <CardSeplag title={titleCard()}>
      <TabView className="sm-invisibleWeb">
        <TabPanel header="Identificação" className="menu-div col" headerTemplate={tabIdentificacaoTemplate}>
          <CardSeplagScrol title="Identificação">
            {exercicio2024 && (
              <div className="div-flex justify-content-end " style={{ paddingRight: "20px", display: "flex" }}>
                <div className="grid">
                  <div
                    className="col text-center border-round-sm bg-primary font-bold"
                    style={{ padding: "0.5rem 1rem !important", alignContent: "center", height: "fit-content" }}
                  >
                    <p style={{ maxWidth: "fit-content" }}>
                      % DE PREENCHIMENTO <br /> DO PROGRAMA
                    </p>
                  </div>
                  <div
                    className="col text-center p-3 border-round-sm bg-primary font-bold"
                    style={{
                      padding: "0.5rem 1rem !important",
                      alignContent: "center",
                      height: "100%",
                      marginLeft: "5px",
                    }}
                  >
                    {formatarPercentual(percent)}
                  </div>
                </div>
              </div>
            )}

            <Rotulo nome="Eixo Vinculado:">
              <label>{form.programa.diretriz.eixo.codgEixo + " - " + form.programa.diretriz.eixo.nomeEixo}</label>
            </Rotulo>
            <hr />
            <Rotulo nome="Objetivo de Estado Vinculado:">
              <label>{form.programa.diretriz.codgDiretriz + " - " + form.programa.diretriz.nomeDiretriz}</label>
            </Rotulo>
            <hr />
            <Rotulo nome="Público Alvo do Programa:">
              <label>{form.programa.descPublicoAlvo}</label>
            </Rotulo>
            <hr />
            <Rotulo nome="Tipo do Programa:">
              <label>
                {form.programa.flagTipoPrograma === "APOIO"
                  ? "Apoio Administrativo"
                  : form.programa.flagTipoPrograma === "FINALISTICO"
                  ? "Finalístico"
                  : form.programa.flagTipoPrograma === "GESTAO"
                  ? "Gestão de Políticas Públicas - Gestão, Manutenção e Serviços do Estado"
                  : ""}
              </label>
            </Rotulo>
            <hr />
            <Rotulo nome="UO Responsável pelo Programa:">
              <label>{dadosItemPrograma?.unidadeOrcamentariaResponsavel?.descUo}</label>
            </Rotulo>
            <hr />

            <div style={{ justifyContent: "space-between", display: "flex" }} className="div-flex">
              <div style={{ width: "75%" }}>
                <Rotulo nome="Responsável:">
                  <label>{form.responsavel}</label>
                </Rotulo>
              </div>

              {exercicio2024 && (
                <div style={{ width: "25%" }}>
                  <Rotulo nome="ODS vinculada:" className="p-col-12" width="70%">
                    <div className="div-flex">
                      {listaOds &&
                        (listaOds ? (
                          listaOds.map((ods) => (
                            <div key={ods.codgOds}>
                              <Image src={getImageSrc(ods.nomeImagem)} alt={ods.nomeImagem} width="60" height="60" />
                            </div>
                          ))
                        ) : (
                          <p> Sem dados de ODS.</p>
                        ))}
                    </div>
                  </Rotulo>
                </div>
              )}

              <hr />
            </div>

            <br />
            <div className="p-fluid grid">
              <div className="field col-12 md:col-8 ">&nbsp;</div>
              <div className="field col-12 md:col-2 "></div>
              <div className="field col-12 md:col-2 ">
                <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
              </div>
            </div>
          </CardSeplagScrol>
        </TabPanel>
        <TabPanel header="Indicadores" className="menu-div col" headerTemplate={tabIndicadoresTemplate}>
          <AvaliacaoProgramaRagIndicador
            condicao={condicao}
            dadosItemPrograma={dadosItemPrograma}
            podeAvaliarIndicador={location.state.podeAvaliarIndicador}
            idenPessoaResp={idenPessoaResp}
            aba={setAbaTelaConfirmada}
          ></AvaliacaoProgramaRagIndicador>
        </TabPanel>
        <TabPanel header="Resultados" className="menu-div col" headerTemplate={tabResultadosTemplate}>
          <AvaliacaoProgramaRagResultado
            dadosItemPrograma={dadosItemPrograma}
            questionario={camposQuestionarioResultado}
            setCamposQuestionarioResultado={setCamposQuestionarioResultado}
            condicao={condicao}
            podeAvaliarPrograma={location.state.podeAvaliarPrograma}
            aba={setAbaTelaConfirmada}
            //PPA={idPPA}
            PPA={location.state.data.idenPPA}
          ></AvaliacaoProgramaRagResultado>
        </TabPanel>
        <TabPanel
          header={exercicio2024 ? "Execução Orçamentária" : "Execução"}
          className="menu-div col"
          headerTemplate={tabExecucaoTemplate}
        >
          <AvaliacaoProgramaRagExecucao
            dadosItemPrograma={dadosItemPrograma}
            questionario={camposQuestionarioExecucao}
            setCamposQuestionarioExecucao={setCamposQuestionarioExecucao}
            condicao={condicao}
            podeAvaliarPrograma={location.state.podeAvaliarPrograma}
            aba={setAbaTelaConfirmada}
          ></AvaliacaoProgramaRagExecucao>
        </TabPanel>
        {
          // esconder aba sugestão para usuários com perfil de órgão de controle
          userPerfil.some((item) => {
            return item.nomeRole !== "MONRL_ACESSO_ORGAO_CONTROLE";
          }) && (
            <TabPanel
              header={exercicio2024 ? "Sugestão de Melhoria" : "Sugestão"}
              className="menu-div col"
              headerTemplate={tabSugestaoTemplate}
            >
              <AvaliacaoProgramaRagSugestao
                dadosItemPrograma={dadosItemPrograma}
                questionario={camposQuestionarioSugestao}
                setCamposQuestionarioSugestao={setCamposQuestionarioSugestao}
                condicao={condicao}
                podeAvaliarPrograma={location.state.podeAvaliarPrograma}
              ></AvaliacaoProgramaRagSugestao>
            </TabPanel>
          )
        }
        {perfilAcesso && (
          <TabPanel
            header={exercicio2024 ? "Análise do Órgão Central" : "Análise SEPLAG"}
            className="menu-div col"
            headerTemplate={tabAnaliseTemplate}
          >
            <AnaliseProgramaSeplag
              dadosItemPrograma={dadosItemPrograma}
              parametroExercicio={parametroExercicio}
              form={form}
              podeAnalisarPrograma={location.state.podeAnalisarPrograma}
            />
          </TabPanel>
        )}
      </TabView>
    </CardSeplag>
  );
};

export default AvaliacaoProgramaRag;
